<div ng-controller="excelReportController as ctrl" class="excel-report">
        <div class="list-filter list-filter-tools" ng-show="ctrl.showFilter">
            <div centuri-list-filter class="list-filter-elements" config="ctrl.filterConfig" callback="ctrl.filterCallback"></div>
        </div>
        <div id="managed-component"></div>
</div>